// utils/funnelPixels.ts — LEGACY funnel helper (sekarang WYSIWYG disabled).
// formPage sudah fire event sesuai dropdown di view (metaPixel.ts:49), jadi tidak
// perlu double-fire di submit. Fungsi ini dibiarkan no-op agar tidak double InitiateCheckout.
// Dipanggil dari submitRpc tapi langsung return — aman, tidak perlu hapus caller.
export function fireFormFunnelEvent(
    _form: any,
    _globalTrackingSettings: any,
    _orderId: string,
    _opts?: { value?: number; email?: string; phone?: string; firstName?: string; lastName?: string }
): void {
    return;
}